// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld/base/core';

/* Provides functions for layers to embed custom views/widgets.
 * @mixin
 */
myw.WidgetRendererMixin = {
    getDefinitions(classList) {
        let widgetDefinitions = [];
        if (classList && classList.indexOf('[') == 0) {
            const definitions = classList
                .replace('[', '')
                .replace(']', '')
                .replace(/ /gi, '')
                .split(',');

            widgetDefinitions = [];

            for (const classItem of definitions) {
                if (myw.Util.evalAccessors(classItem)) {
                    widgetDefinitions.push(myw.Util.evalAccessors(classItem));
                }
            }

            return widgetDefinitions;
        }

        if (classList && classList.length > 0) {
            if (myw.Util.evalAccessors(classList)) {
                widgetDefinitions.push(myw.Util.evalAccessors(classList));
            }
        }

        return widgetDefinitions;
    }
};

export default myw.WidgetRendererMixin;
